/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import TableSortLabel from '@mui/material/TableSortLabel';

export const StyledTableSortLabel = withStyles((theme: Theme) =>
    createStyles({
        icon: {
            color: `${theme.palette.error.main} !important`,
        },
    }),
)(TableSortLabel);
